// src/components/Shared/AnimatedSection.tsx

import React, { useRef, FC } from 'react';
import { motion, Variants, HTMLMotionProps } from 'framer-motion';
import styles from '../../css/Global.module.css'; 

// Extend HTMLMotionProps to allow standard div/section attributes like id, style, etc.
interface AnimatedSectionProps extends HTMLMotionProps<"section"> {
    children: React.ReactNode;
    className?: string;
    variants?: Variants; 
    delay?: number;
}

const AnimatedSection: FC<AnimatedSectionProps> = ({ 
    children, 
    className = '', 
    variants, 
    delay = 0,
    ...props 
}) => {
    const ref = useRef<HTMLElement>(null); 

    // "Premium" animation: Smooth upward drift with a soft fade
    const defaultVariants: Variants = { 
        hidden: { opacity: 0, y: 30 },
        visible: { 
            opacity: 1, 
            y: 0, 
            transition: { 
                duration: 0.8, 
                delay: delay,
                ease: [0.22, 1, 0.36, 1] // Cubic bezier for a high-end "settling" feel
            } 
        }
    };

    return (
        <motion.section
            ref={ref}
            className={`${styles.section} ${className}`}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-100px" }} // Trigger slightly before element hits center
            variants={variants || defaultVariants}
            {...props}
        >
            {children}
        </motion.section>
    );
};

export default AnimatedSection;